import {
  SHOW_POPUP,
  HIDE_POPUP,
  SET_DATA,
  REMOVE_DATA,
  SET_DATA_EDIT,
} from "./actionTypes"

export const showPopup = data => ({
  type: SHOW_POPUP,
  payload:data
})

export const hidePopup = () => ({
  type: HIDE_POPUP,
})

export const setData = data => ({
  type: SET_DATA,
  payload:data
})

export const removeData = (data) => ({
  type: REMOVE_DATA,
  payload:data
})

export const setDataEdit = (data) => ({
  type: SET_DATA_EDIT,
  payload:data
})


